/* ==========================================================================
   Custom mega menu add-on — on-load auto-open guard
   --------------------------------------------------------------------------
   Problem: after clicking a top-level link, the next page loads with the
   cursor parked on that link. Browsers apply the CSS :hover state on the FIRST
   mouse movement after a load, so the dropdown opens the instant the cursor
   moves a pixel — even though the cursor never actually "arrived" by hovering.

   Fix (mechanism- and timing-proof): disable every dropdown trigger up front
   (html.nav-load-lock-all). On the first mouse movement, work out which trigger
   the cursor is parked on, re-enable everything else, and keep only that one
   trigger disabled until the cursor leaves it. Hovering back onto it (the
   "second hover") then opens the dropdown normally. Desktop only.

   This is a NEW file, so theme updates do not overwrite it.
   ========================================================================== */
(function () {
  // Desktop hover only — mobile uses a tap drawer with no hover.
  if (window.matchMedia && !window.matchMedia('(min-width: 768px)').matches) {
    return;
  }

  var html = document.documentElement;
  var ignored = null;
  var released = false;

  // Lock all triggers immediately, before the first move can open anything.
  html.classList.add('nav-load-lock-all');

  function rectHas(el, x, y) {
    var r = el.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function triggerUnder(x, y) {
    var items = document.querySelectorAll('.navigation__item--with-children');
    for (var i = 0; i < items.length; i++) {
      if (rectHas(items[i], x, y)) return items[i];
    }
    return null;
  }

  function releaseGlobal() {
    if (released) return;
    released = true;
    html.classList.remove('nav-load-lock-all');
    document.removeEventListener('mousemove', onFirstMove, true);
    document.removeEventListener('mousedown', onInteract, true);
    document.removeEventListener('keydown', onInteract, true);
  }

  function onFirstMove(e) {
    var parked = triggerUnder(e.clientX, e.clientY);
    releaseGlobal();
    if (parked) {
      // Cursor is sitting on this trigger: keep just this one closed until the
      // cursor leaves it, so the next hover onto it opens the dropdown.
      ignored = parked;
      parked.classList.add('nav-load-lock');
      document.addEventListener('mousemove', onLeave, true);
    }
  }

  function onLeave(e) {
    if (!ignored) return;
    if (!rectHas(ignored, e.clientX, e.clientY)) {
      ignored.classList.remove('nav-load-lock');
      ignored = null;
      document.removeEventListener('mousemove', onLeave, true);
    }
  }

  // A deliberate click or key press (without moving) should free the nav too.
  function onInteract() {
    releaseGlobal();
  }

  document.addEventListener('mousemove', onFirstMove, true);
  document.addEventListener('mousedown', onInteract, true);
  document.addEventListener('keydown', onInteract, true);

  // Safety net: never leave the nav disabled indefinitely.
  setTimeout(releaseGlobal, 12000);
})();

/* ==========================================================================
   Custom mega menu add-on — animated mobile accordion
   --------------------------------------------------------------------------
   Native <details> opens/closes instantly. This animates the height of the
   column accordions (.mega-column__details) created on mobile. Delegated from
   the document so it works no matter when the mobile drawer is built, and it
   falls back to an instant toggle when the user prefers reduced motion.
   ========================================================================== */
(function () {
  var DURATION = 260;

  function finish(details, state, isOpen) {
    details.open = isOpen;
    state.animation = null;
    state.isClosing = false;
    state.isExpanding = false;
    details.style.height = '';
    details.style.overflow = '';
  }

  function animate(details, summary) {
    var content = details.querySelector('.mega-column__details-content');
    if (!content) return;

    // Respect reduced-motion: toggle instantly.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = !details.open;
      return;
    }

    var state = details.__megaAnim || (details.__megaAnim = {});
    details.style.overflow = 'hidden';

    if (state.isClosing || !details.open) {
      // Opening.
      state.isClosing = false;
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(function () {
        var startH = details.offsetHeight;
        var endH = summary.offsetHeight + content.offsetHeight;
        if (state.animation) state.animation.cancel();
        state.isExpanding = true;
        state.animation = details.animate(
          { height: [startH + 'px', endH + 'px'] },
          { duration: DURATION, easing: 'ease' }
        );
        state.animation.onfinish = function () { finish(details, state, true); };
        state.animation.oncancel = function () { state.isExpanding = false; };
      });
    } else {
      // Closing.
      state.isExpanding = false;
      var startH = details.offsetHeight;
      var endH = summary.offsetHeight;
      if (state.animation) state.animation.cancel();
      state.isClosing = true;
      state.animation = details.animate(
        { height: [startH + 'px', endH + 'px'] },
        { duration: DURATION, easing: 'ease' }
      );
      state.animation.onfinish = function () { finish(details, state, false); };
      state.animation.oncancel = function () { state.isClosing = false; };
    }
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('summary.mega-column__summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.classList.contains('mega-column__details')) {
      return;
    }
    e.preventDefault();
    animate(details, summary);
  }, false);
})();
